import './index.css';
import { ViewportProvider } from './hooks/viewportContext';
import useHandleResize from './hooks/useHandleResize';
import {
  createBrowserRouter,
  Route,
  Outlet,
  createRoutesFromElements,
  RouterProvider
} from 'react-router-dom';

// Pages
import Navbar from './components/Navbar';
import Main from './components/Main';
import Footer from './components/Footer';
import ErrorPage from './components/ErrorPage';
import Feedback from './components/Feedback';

function RootLayout() {
  const [width, height] = useHandleResize()

  return (
    <div className="App bg-th-blue-400 h-[105vh] lg:h-screen">
      <ViewportProvider>
        <Navbar
          data={
            [
              { name: "Home", href: "/" },
              { name: "Feedback", href: "feedback" }
            ]
          } />
        <Footer />
      </ViewportProvider>
      <Outlet context={[width, height]}/>
    </div>
  )
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout />} errorElement={<ErrorPage />}>
      <Route index element={<Main />} />
      <Route path="/feedback" element={<Feedback />} />
    </Route>

  )
)

function App() {
  return (
    <div className="App bg-th-blue-400 h-screen">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
